import { Controller } from "@hotwired/stimulus"

// Jira-style status picker with popover.
// data-controller="support--ticket-status"
//
// CONEK-6786: every option in the popover is an agent-facing status
// (Support::BusinessStatus) and carries the full tuple it maps to —
// data-to-state + data-waiting-reason + data-closed-reason — so a click copies
// the three values into the hidden form and submits. The former two-step
// "pick Waiting, then pick a reason" sub-menu is gone: the reason IS the option.
//
// Problems reuse this controller with only the toStateInput target (no
// reasons), so every reason target is guarded with has*Target.
export default class extends Controller {
  static targets = [
    "popover",
    "trigger",
    "form",
    "toStateInput",
    "waitingReasonInput",
    "closedReasonInput",
  ]

  toggle(event) {
    event.stopPropagation()
    const open = this.popoverTarget.classList.contains("hidden")
    this.popoverTarget.classList.toggle("hidden", !open)
  }

  close() {
    this.popoverTarget.classList.add("hidden")
  }

  transition(event) {
    const { toState, waitingReason, closedReason } = event.currentTarget.dataset

    this.toStateInputTarget.value = toState
    if (this.hasWaitingReasonInputTarget) {
      this.waitingReasonInputTarget.value = waitingReason || ""
    }
    if (this.hasClosedReasonInputTarget) {
      this.closedReasonInputTarget.value = closedReason || ""
    }
    this.close()
    this.formTarget.requestSubmit()
  }

  // Legacy: support old "change" event from select (kept for compatibility)
  submit(event) {
    event.currentTarget.closest("form")?.requestSubmit()
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }
}
